import { Download, X } from 'lucide-react';
import { chordName, droneKey } from '@/lib/droneChords';
import { TIMBRES } from '@/lib/droneTimbres';

export const SharedSongBanner = ({ song, onAccept, onDismiss }) => {
  const flats = droneKey(song.transpose).flats;
  const chords = song.steps.map((s) => `${chordName(s.pc, s.quality, flats)}${s.bars > 1 ? `×${s.bars}` : ''}`).join(' – ');
  return (
    <section data-testid="drone-shared-song" className="rounded-2xl border border-sky-400/40 bg-sky-400/10 p-4 flex flex-col sm:flex-row sm:items-center gap-3">
      <div className="flex-1 min-w-0 flex flex-col gap-0.5">
        <div className="text-[10px] uppercase tracking-[0.3em] text-sky-300">Sequenza condivisa</div>
        <div data-testid="drone-shared-song-name" className="font-bebas text-2xl tracking-wide truncate">{song.name || 'Bordone a tempo'}</div>
        <div data-testid="drone-shared-song-chords" className="text-sm font-mono text-white/80 break-words">{chords}</div>
        <div data-testid="drone-shared-song-meta" className="text-xs font-mono text-white/50">
          {song.bpm} BPM · {TIMBRES.find((t) => t.id === song.timbre)?.label} · strumento in {droneKey(song.transpose).label}
        </div>
      </div>
      <div className="flex gap-2">
        <button data-testid="drone-shared-song-accept" onClick={onAccept} className="h-11 px-4 rounded-full bg-sky-400 text-black text-xs font-semibold uppercase tracking-[0.2em] inline-flex items-center gap-2 active:scale-95 transition-transform">
          <Download className="w-4 h-4" /> Carica
        </button>
        <button data-testid="drone-shared-song-dismiss" aria-label="Ignora" onClick={onDismiss} className="h-11 w-11 rounded-full border border-white/15 flex items-center justify-center hover:bg-white/5">
          <X className="w-4 h-4" />
        </button>
      </div>
    </section>
  );
};
